import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showChatButton: true,
};

const chatButtonSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    showChatButton: (state) => {
      state.showChatButton = true;
    },
    hideChatButton: (state) => {
      state.showChatButton = false;
    },
  },
});

export const { showChatButton, hideChatButton } = chatButtonSlice.actions;
export default chatButtonSlice.reducer;
